export const REQUEST_CODE_TIME = 60;
